import htmx from "htmx.org";
import { AlpineComponent } from "@nxtlvlsoftware/alpine-typescript";
import { onOfficeReady } from "../office/state";
import { dispatch } from "../utils/events";
import { pipeline } from "../handlers/updates";
import { LocationHistory } from "../office/LocationHistory";

const _history = new LocationHistory();
(window as any)._history = _history; // For debugging purposes

export default class RestoreLocationButton extends AlpineComponent {
  private _isOfficeOnline = false;

  constructor(
    public trackUrl: string,
    public enabled = false,
    public hasLocation = false) {
    super();
  }

  public init() {
    onOfficeReady(async (enabled) => {
      if (enabled == false) return
      this.enabled = enabled
      this._isOfficeOnline = Office.context.platform === Office.PlatformType.OfficeOnline;

      if (_history.phase === 'unregistered') {
        await _history.register(Word.run);
      }
      this.hasLocation = _history?.hasLocation() ?? false;
    });
  }

  public async saveLocation() {
    if (!this.enabled) return;

    await _history?.push();
    this.hasLocation = true;
  }

  public async restoreLocation() {
    if (!this.enabled || !this.hasLocation) return;

    await _history?.pop();
    if (this._isOfficeOnline) {
      pipeline.ignoreNextModification();
    }
    this.hasLocation = _history?.hasLocation() ?? false;
    await htmx.ajax('get', this.trackUrl, {})
  }

  public async onSaveLocation() {
    await this.saveLocation();
  }

  public async onRestoreLocation() {
    await this.restoreLocation();
  }

  public async onClick() {
    dispatch("restore-location");
  }

}